import React from 'react';
import PropTypes from 'prop-types';
import DtButton from '../Button';

const Button = (props) => <DtButton {...props} buttonType="button_slim" />;

Button.propTypes = {
  colorType: PropTypes.string,
};

export default Button;
